import { CONDITION_TYPE, VALIDATE } from '@cognitiv/cicada-ui';
import { ScheduledBatchState } from 'ducks/scheduled-batch/slices';

export const manage_form_default_state: ScheduledBatchState = {
  scheduled_batch_name: '',
  batch_definition_id: null,
  interval_name: 'One Time',
  interval_id: 1,
  interval_frequency: 1,
  start_datetime_formatted: '',
  finish_datetime_formatted: '',
  last_datetime_formatted: '',
  next_datetime_formatted: '',
  is_active: false,
  interval_bitmask: '0000000',
  scheduled_batch_id: null,
  project_id: null,
  project_name: '',
  organization_id: null,
  organization_name: '',
  batch_definition_name: '',
  start_datetime_utc: '',
  finish_datetime_utc: '',
  next_datetime_utc: '',
  last_datetime_utc: '',
  last_batch_id: null,
  created_by: '',
  created_datetime_utc: '',
  is_archived: false,
  sort_datetime_utc: '',
  timeout_seconds_masked: '',
  start_datetime_utc_slim: '',
  start_datetime_utc_sort: '',
  start_datetime_utc_formatted: '',
  start_datetime_slim: '',
  start_datetime_sort: '',
  last_datetime_utc_sort: '',
  last_datetime_utc_formatted: '',
  last_datetime_sort: '',
  next_datetime_utc_slim: '',
  next_datetime_utc_sort: '',
  next_datetime_utc_formatted: '',
  next_datetime_slim: '',
  next_datetime_sort: '',
  finish_datetime_utc_formatted: '',
  created_datetime_formatted: '',
  created_datetime_utc_formatted: '',
  uuid: '',
  modified: false,
};

export const batch_definition_default_state = {
  batch_definition_name: '',
};

export const schedule_batch_default_state = {
  batch_name: '',
};

export const batch_definition_validation = {
  batch_definition_name: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Batch Definition Name is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
};

export const run_schedule_batch_validation = {
  batch_name: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Batch Name is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
};

export const manage_validation = {
  scheduled_batch_name: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Scheduled Batch Name is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
  batch_definition_name: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Batch Definition is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
  interval_frequency: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Repeat frequency is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
  interval_name: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Interval is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
};
